export const SOCIAL_ACTION_TYPES = {
  POST: "post",
  SCHEDULE: "schedule",
}
